var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagotipoEthics5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.124 5.687c1.273 0 2.31 1.005 2.31 2.253 0 1.241-1.037 2.248-2.31 2.248-1.274 0-2.305-1.007-2.305-2.248 0-1.248 1.03-2.253 2.305-2.253zm0 11.945L3.475 8.057l6.649 5.554 8.042-7.888c-1.82-2.43-4.786-4.013-8.137-4.013C4.49 1.71 0 6.028 0 11.355S4.49 21 10.029 21c5.538 0 10.028-4.318 10.028-9.645a9.313 9.313 0 0 0-1.282-4.716l-8.651 10.993zM24 0l-5.834 5.723c.22.292.424.598.61.916L24 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagotipoEthics5);
export default __webpack_public_path__ + "static/media/imagotipo-ethics_5.d6c8f8c32b11375cf5685423a54d9264.svg";
export { ForwardRef as ReactComponent };